import React from 'react';
import { CampaignFormProvider, useCampaignForm } from '../context/CampaignFormContext';
import { AICopyGeneratorEnhanced } from './AICopyGeneratorEnhanced';
import { CopyHistorySidebar } from './CopyHistorySidebar';

const CampaignFormFields: React.FC = () => {
  const { copy, updateField, canUndo, canRedo, undo, redo } = useCampaignForm();

  return (
    <div className="bg-white dark:bg-boxdark rounded-lg p-6 border border-stroke">
      <h3 className="text-xl font-semibold mb-4">Campaign Details</h3>

      <div className="flex gap-2 mb-4">
        <button
          onClick={undo}
          disabled={!canUndo}
          className="px-4 py-2 border border-stroke rounded-lg hover:bg-gray-50 dark:hover:bg-meta-4 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          ↶ Undo
        </button>
        <button
          onClick={redo}
          disabled={!canRedo}
          className="px-4 py-2 border border-stroke rounded-lg hover:bg-gray-50 dark:hover:bg-meta-4 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          ↷ Redo
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">
            Headline <span className="text-gray-400">({copy.headline.length}/40 chars)</span>
          </label>
          <input
            type="text"
            value={copy.headline}
            onChange={(e) => updateField('headline', e.target.value)}
            maxLength={40}
            placeholder="Enter headline..."
            className="w-full px-4 py-2 border border-stroke rounded-lg dark:bg-boxdark"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Description <span className="text-gray-400">({copy.description.length}/125 chars)</span>
          </label>
          <textarea
            value={copy.description}
            onChange={(e) => updateField('description', e.target.value)}
            maxLength={125}
            placeholder="Enter description..."
            rows={3}
            className="w-full px-4 py-2 border border-stroke rounded-lg dark:bg-boxdark"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Call to Action <span className="text-gray-400">({copy.cta.length}/20 chars)</span>
          </label>
          <input
            type="text"
            value={copy.cta}
            onChange={(e) => updateField('cta', e.target.value)}
            maxLength={20}
            placeholder="e.g., Shop Now"
            className="w-full px-4 py-2 border border-stroke rounded-lg dark:bg-boxdark"
          />
        </div>

        <div className="pt-4 border-t border-stroke">
          <button className="w-full px-6 py-3 bg-success text-white rounded-lg hover:bg-opacity-90 font-medium">
            💾 Save Campaign
          </button>
        </div>
      </div>
    </div>
  );
};

export const CampaignFormWithAI: React.FC = () => {
  return (
    <CampaignFormProvider>
      <div className="p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div>
            <CampaignFormFields />
          </div>
          <div>
            <AICopyGeneratorEnhanced />
          </div>
          <div>
            <CopyHistorySidebar />
          </div>
        </div>
      </div>
    </CampaignFormProvider>
  );
};
